import { CookieStorage } from "cookie-storage";
import constants from "./constants";
// import http from "./http";
import axios from "axios";
const axiosInstance = axios.create({
  baseURL: "",
  timeout: 30000,
});
const cookieStorage = new CookieStorage();

export default {
  performAgentMorph: async (name) => {
    try {
      /*const commandMessageParse = await http.sendCommand(
        "command:agent:morph:name",
        {
          name
        }
      );*/
      const playerAnalysisData = await axiosInstance.get(
        `AgentMorphNameHelper.aspx?agentMorphName=${name}`
      );
      if (playerAnalysisData.data.result !== "-1") {
        cookieStorage.setItem(
          constants.AGENT_ID,
          playerAnalysisData.data.result.idAgent,
          {
            path: "/",
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  },
};
